import { useEffect, useState } from "react";

type SetSearchParams = (
  nextInit: URLSearchParams | ((previous: URLSearchParams) => URLSearchParams),
  navigateOptions?: { replace?: boolean },
) => void;

export type PbiNotice = {
  type: "success" | "error";
  text: string;
};

function getPbiNotice(pbiParam: string | null): PbiNotice | null {
  if (pbiParam === "connected") {
    return { type: "success", text: "Power BI connected successfully." };
  }

  if (pbiParam === "error") {
    return {
      type: "error",
      text: "Power BI connection failed. Please try again from your profile.",
    };
  }

  return null;
}

export function usePbiNotice(
  pbiParam: string | null,
  setSearchParams: SetSearchParams,
) {
  const [notice] = useState(() => getPbiNotice(pbiParam));

  useEffect(() => {
    if (!getPbiNotice(pbiParam)) return;

    setSearchParams((previous) => {
      const next = new URLSearchParams(previous);
      next.delete("pbi");
      return next;
    }, { replace: true });
  }, [pbiParam, setSearchParams]);

  return notice;
}
